import CustomAvatar from "./Avatar";

const SprintAvatar = {
  CustomAvatar,
};

export default SprintAvatar;
